import Config from "../config";

export const concatBaseMediaUrl = url => {
    return `${Config.ENVIRONMENTS[Config.ENVIRONMENT].BASE_IMG_PATH}/${url}`;
};